import { jwtDecode } from 'jwt-decode'

const userCheck = () => jwtDecode(localStorage.getItem('token')).role === 'user'

const adminCheck = () => jwtDecode(localStorage.getItem('token')).role === 'admin'

const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export {
  userCheck,
  adminCheck,
  capitalizeFirstLetter,
}